module.exports = __webpack_public_path__ + "static/media/career-image.28a8e06d.jpg";